export const getAvatarData = (name?: string) => {
  const colors =[
    '#E199FD', 
    '#B197FC', 
    '#91A6FF', 
    '#71C1FE', 
    '#FBA2C0', 
    '#FFA8A7', 
    '#FEE066', 
    '#FFC179'
  ];
  
  const safeName = (name || 'U').trim();
  const initial = safeName.charAt(0).toUpperCase() || 'U';
  const charCode = initial.charCodeAt(0);
  
  const color = colors[charCode % colors.length];
  
  return { 
    initial, 
    color,                
    textColor: '#FFFFFF' 
  };
};